import Icon from '../components/Icon.vue'

Icon.register({
  'crop-alt': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M488 352H448V96C448 78.3 433.7 64 416 64H192V160H352V488C352 501.3 362.8 512 376 512H424C437.3 512 448 501.3 448 488V448H488C501.3 448 512 437.3 512 424V376C512 362.7 501.3 352 488 352zM160 24C160 10.7 149.3 0 136 0H88C74.8 0 64 10.7 64 24V64H24C10.8 64 0 74.7 0 88V136C0 149.3 10.8 160 24 160H64V416C64 433.7 78.3 448 96 448H320V352H160V24z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/crop-alt.js
// module id = 7e4g
// module chunks = 144